import React from "react";
import { AspectRatio, Box, Flex, Text } from "@chakra-ui/layout";
import Image from "next/image";

import { getStaticFile } from "utils/getStaticFile";
import { colours, shadows } from "@shared/ui.design-system";
import { space } from "theme/themeConfig";
import { Link } from "components/Link";
import { useSegment } from "tracking";
import type { ProductListVariants } from "components/BasketLists/ProductList/ProductList";

interface Props {
  variant?: ProductListVariants;
  locationUrl: string;
}

export const QuizLink: React.FC<Props> = ({ variant, locationUrl }) => {
  const QUIZ_HREF = `/quiz/skincare?from=${locationUrl}`;
  const { track } = useSegment();
  const handleClick = () => {
    track({
      event: "Page Element Clicked",
      properties: {
        module_content: "Quiz Link Experiment",
        module_content_url: QUIZ_HREF
      }
    });
  };

  const isATBConfirmation = variant === "atbConfirmation";

  return (
    <Flex
      marginTop={isATBConfirmation ? 0 : space[2]}
      marginBottom={space[2]}
      boxShadow={isATBConfirmation ? shadows.bottom.l1 : "none"}
      borderRadius={space[-2]}
      backgroundColor={
        isATBConfirmation ? colours.secondary.light : colours.accent.light
      }
      data-testid="quiz-link-wrapper"
    >
      <AspectRatio minH={112} minW={112} ratio={1} position="relative">
        <Image
          src="/images/search/quiz-insert.jpg"
          placeholder="blur"
          blurDataURL={getStaticFile("/images/placeholder.svg")}
          alt="Quiz insert image"
          width={112}
          height={112}
          style={{
            overflow: "hidden",
            borderRadius: `${space[-2]} 0 0 ${space[-2]}`,
            objectFit: "cover",
            objectPosition: "center"
          }}
        />
      </AspectRatio>

      <Box padding={space[1]}>
        <Text
          marginTop={0}
          marginBottom={space[-1]}
          variant="acuminLight"
          color={colours.primary.dark}
        >
          Find the products that will work magic on your skin.
        </Text>
        <Link
          href={QUIZ_HREF}
          variant="acuminRegular"
          textDecoration="underline"
          marginTop={0}
          onClick={handleClick}
          data-testid="quiz-link-anchor"
        >
          Take the quiz
        </Link>
      </Box>
    </Flex>
  );
};
